import gql from "graphql-tag";
import {
    CustomerFragment,
    EmployerFragment,
    TransporterFragment
} from "../../Queries/Organization";
import {LocationFragment} from "../../Queries/Location";

export const PassengerEditorPersonFragment = gql`
    fragment PassengerEditorPersonFragment on Person {
        _id
        dob
        nation
        notes
        employerID {
            ...EmployerFragment
        }
        contactInfo {
            phone {
                number
                type
            }
        }
    }
    ${EmployerFragment}
`

export const PassengerEditorCarrierFragment = gql`
    fragment PassengerEditorCarrierFragment on Carrier {
        ... on FlightNode {
            _id
            desig
            legs
            classType
            customerID {
                ...CustomerFragment
            }
            tpID {
                ...TransporterFragment
            }
            legsArray {
                bagCount
                bagWeight
                cgoCount
                cgoIDs {
                    _id
                    weight
                }
                cgoWeight
                chosen
                departure
                departureID
                destination
                destinationID
                order
                paxCount
                paxIDs {
                    _id
                    paxWeight
                    bagWeight
                    bagCount
                }
                paxWeight
                seats
                usefulLoad
                flightTime
            }
        }
        ... on BoatNode {
            _id
            desig
            classType
        }
    }
    ${CustomerFragment}
    ${TransporterFragment}
`

export const PassengerEditorPaxNodeFragment = gql`
    fragment PassengerEditorPaxNodeFragment on PaxNode {
        _id
        firstName
        lastName
        currentCarrierDoc {
            ...PassengerEditorCarrierFragment
        }
        personID {
        ...PassengerEditorPersonFragment
        }
        customerID {
            ...CustomerFragment
        }
        tpID {
            ...TransporterFragment
        }
        employerID {
            ...EmployerFragment
        }
        checkedInTime
        checkInType
        scheduledFlightDate
        departureID {
            ...LocationFragment
        }
        destinationID {
            ...LocationFragment
        }
        lastKnownController {
            ...LocationFragment
        }
        paxWeight
        bagWeight
        bagCount
        chargeCode
    }
    ${LocationFragment}
    ${TransporterFragment}
    ${EmployerFragment}
    ${CustomerFragment}
    ${PassengerEditorPersonFragment}
    ${PassengerEditorCarrierFragment}
`

export const PassengerQuery = gql`
    query PassengerEditorPassengerQuery(
        $paxId: ID!
    ){
        getPassenger(
            _id: $paxId
        ){
            ...PassengerEditorPaxNodeFragment
        }
    }
    ${PassengerEditorPaxNodeFragment}
`;

export const UpdatePassenger = gql`
    mutation PassengerEditor_UpdatePassenger(
        $paxPayload: PaxNodeInput!
    ){
        setPaxNode(payload: $paxPayload){
            ...PassengerEditorPaxNodeFragment
        }
    }
    ${PassengerEditorPaxNodeFragment}
`

export const UpdatePassengerAndFlight = gql`
    mutation PassengerEditor_UpdatePassengerAndFlight(
        $paxPayload: PaxNodeInput!,
        $orgID: ID!,
        $flightPayload: FlightNodeInput!
    ){
        setPaxNode(payload: $paxPayload){
            ...PassengerEditorPaxNodeFragment
        }
        setFlight(payload: $flightPayload, orgID: $orgID){
            ...PassengerEditorCarrierFragment
        }
    }
    ${PassengerEditorPaxNodeFragment}
    ${PassengerEditorCarrierFragment}
`

export const RemovePassengerFromFlight = gql`
    mutation PassengerEditor_RemovePaxFromFlight($flightId: ID!, $paxId: ID!){
        removePaxCgoFromFlight(flightID: $flightId, paxIDs: [$paxId], cgoIDs: []){
            flight {
                ...PassengerEditorCarrierFragment
            }
            paxNodes {
                ...PassengerEditorPaxNodeFragment
            }
        }
    }
    ${PassengerEditorPaxNodeFragment}
    ${PassengerEditorCarrierFragment}
`

export const DeletePaxNode = gql`
    mutation PassengerEditor_DeletePaxNode($paxId: ID!){
        deleteCarriables(carriableIds: [$paxId]){
            deletedCarriableId
            updatedTransport {
                ...PassengerEditorCarrierFragment
            }
        }
    }
    ${PassengerEditorCarrierFragment}
`